import { useEffect, useRef } from "react";
import { Outlet } from "react-router-dom";
import { Loading } from "@app/components";
import { useMasterTables } from "../utils/useMasterTables";

export default function MasterTablesListLayout() {
  const fetched = useRef(false);

  const { fetchGenericTables, loading } = useMasterTables();

  useEffect(() => {
    if (!fetched.current) {
      fetched.current = true;
      fetchGenericTables();
    }
  }, []);

  return loading ? <Loading /> : <Outlet />;
}
